import { WorkOrderScheduleEntry } from '../../../clients/quipli-service/availability/availability';
import { QuipliLink } from '../../../components/link/quipli-link';
import './schedule-tooltip.scss';

export const WorkOrderTooltip = ({ workOrderScheduleEntry }: { workOrderScheduleEntry: WorkOrderScheduleEntry }) => {
  return (
    <div className="work-order-tooltip">
      <div>
        <QuipliLink to={`workorders/view/${workOrderScheduleEntry.workOrderId}`} v2Link={true}>
          Work Order
        </QuipliLink>
      </div>
      <div>
        <span className="tooltip-label">Status:</span> {workOrderScheduleEntry.workOrderStatus}
      </div>
      <div>
        <span className="tooltip-label">Start:</span> {workOrderScheduleEntry.from.toFormat('D t')}
      </div>
      <div>
        <span className="tooltip-label">End:</span> {workOrderScheduleEntry.to?.toFormat('D t') || '-'}
      </div>
    </div>
  );
};
